import {CountdownTimer} from './CountdownTimer';
import React, {useEffect, useRef, useState} from 'react';
import {IconClose} from '@arco-design/web-react/icon';
import {NiuniuResult} from './NiuniuResult';
import {pc28Display} from '../utils/pc28Display';
import {classify} from '../utils/analysis';
import {ResultText} from './ResultText';
const red=new Set([1,2,7,8,12,13,18,19,23,24,29,30,34,35,40,45,46]);
const blue=new Set([3,4,9,10,14,15,20,25,26,31,36,37,41,42,47,48]);
export function PeekDialog({draw, kind='six', onClose,nextIssue,nextTime,onRefresh,refreshing=false,error}) {
  const dialog=useRef(null);
  const [reveal,setReveal]=useState(()=>({issue:draw.issue,values:draw.numbers.map(()=>0)}));
  const progress=reveal.issue===draw.issue?reveal.values:draw.numbers.map(()=>0);
  const setProgress=update=>setReveal(previous=>{
    const values=previous.issue===draw.issue?previous.values:draw.numbers.map(()=>0);
    return {issue:draw.issue,values:typeof update==='function'?update(values):update};
  });
  useEffect(()=>{
    const previous=document.activeElement;
    const bodyOverflow=document.body.style.overflow;
    document.body.style.overflow='hidden';
    dialog.current.showModal();
    return ()=>{document.body.style.overflow=bodyOverflow;previous?.focus();};
  },[]);
  const allRevealed=progress.every(value=>value>=95);
  const pcResult=kind==='pc'&&allRevealed?pc28Display(draw.numbers):null;
  const set=(index,value)=>setProgress(p=>p.map((v,i)=>i===index?value:v));
  const move=(e,i)=>{
    if(!e.currentTarget.hasPointerCapture(e.pointerId)) return;
    const box=e.currentTarget.getBoundingClientRect();
    set(i,Math.max(0,Math.min(100,(e.clientX-box.left)/box.width*100)));
  };
  return <dialog ref={dialog} className="peek-dialog" aria-labelledby="peek-title" onCancel={e=>{e.preventDefault();onClose();}}>
    <div className="section-heading"><div><h2 id="peek-title">咪牌模式</h2></div><button aria-label="关闭咪牌模式" onClick={onClose}><IconClose/></button></div>
    {nextIssue&&<div className="peek-next-status"><span>下期 <strong>{nextIssue}</strong> 期</span><CountdownTimer isTimestamp initialTime={nextTime||0} term="咪牌下期开奖状态"/></div>}
    <p className="peek-current-issue">第 {draw.issue} 期 · 已开奖</p>
    {error&&<p className="notice error" role="alert">{error}</p>}
    <div className={`peek-grid ${kind==='six'?'six':'pc'}`}>{draw.numbers.map((number,i)=>{
      const revealed=progress[i]>=95;
      const color=(kind==='niuniu'||kind==='pc')?(number>=5?'red':'blue'):red.has(number)?'red':blue.has(number)?'blue':'green';
      const label=kind==='six'?`${draw.zodiacs?.[i]||'—'}/${draw.elements?.[i]||'—'}`:kind==='niuniu'?['闲家A','闲家B','庄'][i]:`号码${i+1}`;
      return <div className={`peek-item ball-item ${color}`} key={i}>
        {kind==='six'&&i===6&&<span className="peek-special">特码</span>}
        <div className="peek-slot" role="slider" tabIndex={0} aria-label={`第${i+1}个号码揭晓进度`} aria-valuemin={0} aria-valuemax={100} aria-valuenow={Math.round(progress[i])} aria-valuetext={revealed?`已揭晓 ${number} ${label}`:'待揭晓'}
          onPointerDown={e=>{e.currentTarget.setPointerCapture(e.pointerId);move(e,i);}} onPointerMove={e=>move(e,i)} onPointerUp={e=>{move(e,i);e.currentTarget.releasePointerCapture(e.pointerId);}}
          onKeyDown={e=>{if(['ArrowRight','ArrowUp','ArrowLeft','ArrowDown','Home','End','Enter',' '].includes(e.key)){e.preventDefault();set(i,e.key==='Home'?0:['End','Enter',' '].includes(e.key)?100:Math.max(0,Math.min(100,progress[i]+(['ArrowRight','ArrowUp'].includes(e.key)?10:-10))));}}}>
          <span aria-hidden="true" className={`ball ${color}`}>{kind==='six'?String(number).padStart(2,'0'):number}</span>
          <div aria-hidden="true" className="peek-cover" style={{clipPath:`inset(0 0 0 ${progress[i]}%)`}}>KKAA</div>
        </div><small style={{color:revealed?undefined:'var(--muted)'}}>{revealed?label:'待揭晓'}</small>
      </div>;
    })}</div>
    {kind==='pc'&&<div className="peek-pc-result" aria-live="polite" aria-atomic="true">
      {pcResult?<><span className="peek-result-total">和值 <strong>{pcResult.total}</strong></span><div className="peek-result-labels">
        {['size','parity','dragon'].map(play=><ResultText key={play} value={classify(draw,'pc',play)}/>)}
        {[pcResult.extreme,pcResult.shape].filter(value=>value!=='—').map(value=><ResultText key={value} value={value}/>)}</div></>:<span className="muted">全部揭晓后显示结果</span>}
    </div>}
    {kind==='niuniu'&&allRevealed&&<NiuniuResult numbers={draw.numbers} status/>}
    <p className="peek-instruction">按住遮罩向右滑动，逐步揭晓号码。<span className="peek-keyboard-tip">也可使用方向键或 Enter。</span></p>
    <div className="peek-footer"><p className="muted">仅改变展示方式，不影响开奖结果。</p><div><button onClick={onRefresh} disabled={refreshing}>{refreshing?'刷新中…':'刷新'}</button><button className="primary-button" onClick={()=>setProgress(draw.numbers.map(()=>100))}>全部揭晓</button></div></div>
  </dialog>;
}
